import {FC, useMemo} from 'external/react'
import PlanInfo from 'components/PlanInfo'
import SelectTutor from 'components/SelectTutor'
import SelectStudent from 'components/SelectStudent'
import { UserPackageDetails } from 'types/context/parent'
import CourseList from 'components/CourseList'

type PackageTabProps = {
   packageItem: UserPackageDetails
   role: 'student' | 'tutor'
}

const PackageTab:FC<PackageTabProps> = props => {

    const {packageItem, role} = props
    const [courses, elective] = useMemo(() => [
        packageItem.courses.filter(c => !c.id.startsWith('C7')),
        packageItem.courses.filter(c => c.id.startsWith('C7'))
    ], [packageItem.courses])

	return (<div className='py-3'>

			<div className='d-flex gap-3'>
                <PlanInfo className = 'p-0 flex-grow-1 mb-3' packageItem={packageItem} />
                {role === 'student' && <SelectTutor packageItem={packageItem} />}
                {role === 'tutor' && <SelectStudent packageItem={packageItem} />}
			</div>
			<CourseList courses={courses} source='basic' />
			<CourseList courses={elective} source='elective' />
    </div>)
}

export {PackageTab as default}